import { renderCellContent } from "./cellContent";
import { useState } from "react";
import "../css/GeneralCss.css";
import EditRoomModal from "./RoomModal";
import { ActionsDropdown } from "./ActionsDropDown";
import { useTranslation } from "react-i18next";
import { ChevronUp, ChevronDown } from "lucide-react";
export const TableComponent = ({ columns, data, rooms, page, onDelete, onEdit, getRowUrl,statusOptions,onFilterChange,onSort }) => {
  const [selectedRow, setSelectedRow] = useState({});
  const [roomFilter, setRoomFilter] = useState(""); // currently selected room filter
  const [showRoomFilter, setShowRoomFilter] = useState(false); // toggle dropdown
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const [statusFilter, setStatusFilter] = useState("");
  const [showStatusFilter, setShowStatusFilter] = useState(false);
  // const roomOptions = ["A101", "A102", "A103", "B201"]; // static dropdown options

  const [show, setShow] = useState(false);
  const { t } = useTranslation();

  const handleEdit = (rowData, isFeed) => {
    if (onEdit && page !== "room") {
      onEdit(rowData, isFeed);
    } else {
      setSelectedRow(rowData);
      setShow(true);
    }
  };

  const handleDelete = (rowData) => {
    if (onDelete) {
      onDelete(rowData);
    } else {
      console.log("Delete:", rowData);
    }
  };

  const handleClose = () => setShow(false);

  const filteredData = data.filter((row) => {
    if (page === "student" && roomFilter) {
      return row.rooms.includes(roomFilter); 
    }
     if (page === "student" && statusFilter) {
    if (row.status?.toLowerCase() !== statusFilter) return false;
  }
    return true; 
  });

  const parseDurationToMonths = (duration) => {
    if (!duration) return 0;

    const lower = duration.toLowerCase();
    let months = 0;

    const yearMatch = lower.match(/(\d+)\s*year/);
    const monthMatch = lower.match(/(\d+)\s*month/);

    if (yearMatch) months += parseInt(yearMatch[1], 10) * 12;
    if (monthMatch) months += parseInt(monthMatch[1], 10);

    return months;
  };
  const sortedData = [...filteredData];

  const handleSort = (col) => {
    const newDirection = sortConfig.key === col && sortConfig.direction === "asc" ? "desc" : "asc";
    setSortConfig({ key: col, direction: newDirection });
    onSort?.(col, newDirection);
  };

  return (
    <div>
      <table className="w-100 text-color">
        <thead>
          <tr className="table-background">
            {columns.map((col, index) => {
              const isSortable =
                (page === "room" || page === "student") &&
                (col === "age" || col === "room" || col === "name");
                const isFilter = (page === "student" &&col === "status" );
              return (
                <th
                  key={index}
                  className={`py-2 px-2 fw-bold fs-6 table-header ${
                    isSortable ? "sortable" : "" 
                  } ${sortConfig.key === col ? "sorted" : ""} ${ isFilter? "filter":""}`}
                  style={{ position: "relative" }} // needed for absolute dropdown
                  onClick={() => {
                    if (page === "student" && col === "rooms") {
                      setShowRoomFilter(!showRoomFilter);
                      setShowStatusFilter(false);        // close other dropdown
                    }else if (page === "student" && col === "status") {
                      setShowStatusFilter(!showStatusFilter);
                      setShowRoomFilter(false);          // close other dropdown
                    } 
                     else if (isSortable) {
                      handleSort(col);
                    }
                  }}
                >
                  <span>{t(`table.${col}`)}</span>
                  {sortConfig.key === col &&
                    col !== "rooms" &&
                    (sortConfig.direction === "asc" ? (
                      <ChevronUp size={12} />
                    ) : (
                      <ChevronDown size={12} />
                    ))}

                  {showStatusFilter && page === "student" && col === "status" && (
                    <div className="filter-dropdown">
                      {statusOptions?.map((opt, i) => (
                        <div
                          key={i}
                          className="filter-item"
                          onClick={(e) => {
                            e.stopPropagation();
                            setStatusFilter(opt.value);
                            setShowStatusFilter(false);
                            onFilterChange?.("status", opt.value);
                          }}
                        >
                          {opt.label}
                        </div>
                      ))}
                      <div
                        className="filter-item clear-filter"
                        onClick={(e) => {
                          e.stopPropagation();
                          setStatusFilter("");
                          setShowStatusFilter(false);
                          onFilterChange?.("status", "");
                        }}
                      >
                        {t("table.clearFilter")}
                      </div>
                    </div>
                  )}
                </th>
              );
            })}
          </tr>
        </thead>

        <tbody>
          {sortedData.map((row, index) => (
            <tr
              key={index}
              className={index % 2 !== 0 ? "table-background" : ""}
            >
              {columns.map((col, i) => (
                <td
                  className={`py-2 px-2 text-12 fw-semibold user-select-none ${
                    (page === "student" ||
                      page === "staff" ||
                      page === "room") &&
                    (col === "name" || col === "room")
                      ? "hover-underline"
                      : ""
                  }`}
                  key={i}
                  onClick={() =>
                    page === "room"
                      ? onEdit(row, col)
                      : (page === "student" || page === "staff") &&
                        col === "name" &&
                        handleEdit(row, true)
                  }
                >
                  {col === "actions" ? (
                    <ActionsDropdown
                      rowData={row}
                      // If onEdit prop is not passed from the parent, pass null to the dropdown to hide edit option
                       onEdit={onEdit ? handleEdit : null}
                      onDelete={handleDelete}
                    />
                  ): (col === "name" || col === "room") && getRowUrl ? (
                        <a
                          href={getRowUrl(row)}
                          onClick={(e) => e.preventDefault()}
                          style={{ textDecoration: "none", color: "inherit" }}
                        >
                          {renderCellContent(col, row ,page)}
                        </a>
                      ) : (
                    renderCellContent(col, row,page)
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {page === "room" && (
        <EditRoomModal
          open={show}
          onClose={handleClose}
          modalName={"edit"}
          data={selectedRow}
        />
      )}
    </div>
  );
};
